import { DateValue, getLocalTimeZone, today } from "@internationalized/date";

export function now() {
  return today(getLocalTimeZone());
}

export function beforeCurrentDateFilter(date: DateValue) {
  return date.compare(now()) < 0;
}

export function afterCurrentDateFilter(date: DateValue) {
  return date.compare(now()) > 0;
}
